import React, { Component } from 'react';
import { Input, Modal, Button, message, Spin, Icon } from 'antd';
import CascaderCity from '../../../common/CascaderCity';
import AssignEmployee from './AssignEmployee';
import RequirementDescribe from './RequirementDescribe';
import RequirementInformation from './RequirementInformation';
import AssignedUser from '../tables/AssignedUser';
import AssignHistory from '../tables/AssignHistory';
import Employees from '../tables/Employees';
import Fte from '../tables/Fte';
import InvestigationInfo from '../tables/InvestigationInfo';
import ExportUtil from '../../../../common/ExportUtil';
import $ from '../../../../common/AjaxRequest';
import API_URL from '../../../../common/url';

const { TextArea } = Input;
const DefaultPagination = {
    current: 1,
    pageSize: 10,
};
const typeInConfig = {
    handle: {
        title: 'FTE需求处理',
    },
    rehandle: {
        title: 'FTE需求重新处理',
        hasHistory: true,
    },
    reContribute: {
        title: 'FTE需求重新分配',
        hasHistory: true,
    }
};

let config = {};
const genConfig = (type) => {
    return {
        ...typeInConfig[type],
        [type]: true
    };
};

class ProcessRequirement extends Component {
    state = {
        visible: false,
        loading: false,
        fteList: [],
        employees: [],
        processList: [],
        rejectHistory: [],
        assignmentList: [],
        reRender: true,
        pagination: { ...DefaultPagination },
        searchParams: {},
        detailParams: {},
        requirementExplain: '',
    }

    search = () => {
        const { pagination } = this.state;
        pagination.current = 1;
        this.setState({ pagination }, () => {
            this.loadData();
        });
    }

    loadData = () => {
        const { pagination, searchParams } = this.state;
        const { requirementInfos, ...rest } = searchParams;
        const { current, pageSize } = pagination;
        this.setState({ loading: true });
        const options = {
            method: 'POST',
            url: API_URL.member.fteSettleInfo,
            data: {
                offset: current,
                limit: pageSize,
                ...rest
            },
            doneResult: res => {
                const { fteList, employees, rejectHistory, totalCount } = res.data;
                pagination.total = totalCount;
                this.setState({
                    fteList,
                    employees,
                    pagination,
                    rejectHistory,
                    loading: false,
                });
            },
        };
        $.sendRequest(options);
    }

    queryDetail = () => {
        const { searchParams: { requirementId, requirementInfos } } = this.state;
        const options = {
            method: 'POST',
            url: API_URL.member.getRequirementDetail,
            data: { requirementId },
            doneResult: res => {
                const {
                    requirement,
                    requirementPiList,
                    assignmentList,
                } = res.data;
                const {
                    site,
                    requirementComment,
                    requirementInfo,
                    requirementCode,
                    requireUserCode,
                    requireUser,
                } = requirement || {};
                const {
                    city,
                    investigation,
                    investigationSiteName,
                    courtyardArea,
                    departmentName,
                } = site || {};
                const detailParams = {
                    city,
                    requireUser,
                    requireUserCode,
                    requirementCode,
                    requirementComment,
                    investigationSiteName,
                    ...requirementInfo,
                    courtyardArea,
                    departmentName,
                };
                const { current, ...rest } = requirementInfos;
                detailParams.requirementInfos = current ? { [current]: rest[current] } : rest;
                
                this.setState({
                    loading: false,
                    investigation,
                    detailParams,
                    requirementPiList,
                    assignmentList,
                });
            },
        };
        $.sendRequest(options);
    }

    show = (params, type) => {
        const { unblindingRisk, unblindingRiskLevel } = params;
        config = genConfig(type);
        this.setState({
            visible: true,
            searchParams: params,
            pagination: { ...DefaultPagination },
        }, () => {
            this.queryDetail();
            this.loadData();
            if (unblindingRisk) {
                let unblindingRiskLevelShow = '';
                switch (unblindingRiskLevel) {
                    case 'HIGH':
                        unblindingRiskLevelShow = '高';
                        break;
                    case 'MIDDLE':
                        unblindingRiskLevelShow = '中';
                        break;
                    case 'LOW':
                        unblindingRiskLevelShow = '低';
                        break;
                }
                Modal.info({
                    title: `医院科室存在破盲风险，破盲风险等级${unblindingRiskLevelShow}`,
                    content: '',
                    onOk() {},
                    okText:'确定',
                });
            }
        });
    }

    hide = () => {
        this.setState({
            visible: false,
            reRender: false,
            fteList: [],
            employees: [],
            processList: [],
            rejectHistory: [],
            assignmentList: [],
            requirementExplain: '',
        }, () => {
            this.setState({ reRender: true })
        });
    }

    // 解除分配
    releaseContribute = record => {
        const { searchParams: { requirementId } } = this.state;
        const { userId, assignmentId } = record;
        const options = {
            method: 'POST',
            url: API_URL.member.releaseEmployee,
            data: {
                userId,
                assignmentId,
                requirementId,
            },
            doneResult: res => {
                message.success(res.success);
                this.queryDetail();
                this.loadData();
                this.props.loadData();
            },
        };
        $.sendRequest(options);
    }

    process = user => {
        const { processList } = this.state;
        processList.push(user);
        this.setState({ processList });
    }

    removeProcess = user => {
        const { processList } = this.state;
        const index = (processList || []).findIndex(i => i.userId == user.userId);
        processList.splice(index, 1);

        this.setState({ processList });
    }

    handleSubmit = () => {
        const { processList, searchParams: { requirementId }, requirementExplain } = this.state;
        if (!processList.length) {
            message.warning('尚未分派人员');
            return;
        }
        const params = {};
        processList.forEach(item => {
            params[`intDate[${item.userId}]`] = item.entryDate;
            params[`intMap[${item.userId}]`] = item.vitaeId;
        });
        this.setState({ loading: true });
        const options = {
            method: 'POST',
            url: API_URL.member.assignEmployee,
            data: {
                ...params,
                requirementId,
                requirementExplain,
            },
            doneResult: () => {
                message.success('分派成功');
                this.hide();
                this.setState({ loading: false }, () => {
                    this.props.loadData();
                });
            },
            errorResult: () => {
                this.setState({ loading: false });
            }
        };
        $.sendRequest(options);
    }

    handleInputChange = (e, key) => {
        const { searchParams } = this.state;
        searchParams[key] = e.target.value;
        this.setState({ searchParams });
    }

    changeReason = e => {
        this.setState({ requirementExplain: e.target.value });
    }

    handleTableChange = (params) => {
        this.setState({ ...params }, () => {
            this.loadData();
        });
    }

    handleCascaderCityChange = (value, selectedOptions) => {
        const { searchParams } = this.state;
        const [provinceId, workCityId] = value || [];
        searchParams.provinceId = provinceId;
        searchParams.workCityId = workCityId;
        this.setState({ searchParams });
    }

    showAssignEmployee = record => {
        this.assignEmployeeRef.show(record);
    }

    // 跳转至CRC资源平台
    openCrcSourcePlatform = () => {
        const { userName, crcSourcePlatformUrl } = sessionStorage;
        const { detailParams: { city, requirementCode } } = this.state;
        window.open(`${atob(crcSourcePlatformUrl)}/filter=InvReqUserFte%2FCity%20eq%20'${city}'%20and%20InvReqUserFte%2FLeaderName%20eq%20'${userName}'%20and%20ODS_CTMS_InvReq%2FRequirementCode%20eq%20'${requirementCode}'`);
    }

    download = (vitaeId) => {
        ExportUtil.export({ vitaeId, typeName: 'DOCX' }, null, API_URL.personal.downloadVitaeByType);
        message.success('正在下载中!')
    }

    render() {
        const { showEmployeeDetail } = this.props;
        const {
            visible,
            loading,
            reRender,
            pagination,
            detailParams,
            searchParams,
            requirementPiList = [],
            requirementExplain,
            investigation,
            rejectHistory,
            assignmentList,
            processList,
            employees,
            fteList,
        } = this.state;
        const { keyword, workCityId, provinceId, investigationId } = searchParams;
        const { curRole } = sessionStorage;
        const showCrcSourcePlatform = curRole == 'BO' || curRole == 'CRCC' || curRole == 'CRCM';
        return (
            <Modal
                title={config.title}
                visible={visible}
                onOk={this.handleSubmit}
                onCancel={this.hide}
                wrapClassName="vertical-center-modal"
                bodyStyle={{ maxHeight: 600 }}
                confirmLoading={loading}
                maskClosable={false}
                zIndex={1000}
                width="1000px"
            >
                <Spin spinning={loading}>
                    <div style={{ lineHeight: '32px' }}>1.项目概要信息</div>
                    <InvestigationInfo data={investigation} />
                    <RequirementDescribe visible={visible} investigationId={investigationId} />
                    <div style={{ lineHeight: '32px' }}>2.需求信息</div>
                    <RequirementInformation data={detailParams} piList={requirementPiList} />
                    {
                        config.hasHistory &&
                        <div>
                            <div style={{ marginTop: 20, paddingTop: 10, lineHeight: '32px', borderTop: '1px solid #d1d1d1' }}>分派历史记录</div>
                            {
                                config.rehandle ?
                                    <AssignHistory data={rejectHistory} showEmployeeDetail={showEmployeeDetail} />
                                :
                                    <AssignedUser data={assignmentList} editable={true} releaseContribute={this.releaseContribute} showEmployeeDetail={showEmployeeDetail} />
                            }
                        </div>
                    }
                    <div style={{ marginTop: 20, lineHeight: '32px', borderTop: '1px solid #d1d1d1' }}>本需求还未分配人员情况</div>
                    <Fte data={fteList} />
                    <div style={{ marginTop: 20, paddingTop: 14, borderTop: '1px solid #d1d1d1' }}>
                        <div style={{ display: "block", marginBottom: 10, overflow: 'hidden' }}>
                            <label style={{ lineHeight: "38px" }}>
                                符合需求人员-已被占用FTE情况
                            </label>
                            <div className="filter-bar" style={{ float: "right" }}>
                                <div className="form-item">
                                    <label className="ui-label">工作城市</label>
                                    {
                                        reRender &&
                                        <CascaderCity
                                            style={{ width: 125 }}
                                            value={workCityId ? [provinceId, workCityId] : []}
                                            onChange={(value, selectedOptions) => this.handleCascaderCityChange(value, selectedOptions)}
                                        />
                                    }
                                </div>
                                <div className="form-item">
                                    <label className="ui-label">人员</label>
                                    <Input
                                        placeholder="请输入工号\姓名"
                                        onChange={e => this.handleInputChange(e, 'keyword')}
                                        value={keyword}
                                    />
                                </div>
                                <Button type="primary" onClick={this.search}>搜索</Button>
                                {
                                    showCrcSourcePlatform &&
                                    <Button
                                        style={{ color: '#FFF', background: '#62cf96', border: '1px solid #62cf96' }}
                                        onClick={this.openCrcSourcePlatform}
                                    >CRC资源平台</Button>
                                }
                            </div>
                        </div>
                    </div>
                    <Employees
                        data={fteList}
                        employees={employees}
                        processList={processList}
                        showEmployeeDetail={showEmployeeDetail}
                        showAssignEmployee={this.showAssignEmployee}
                        pagination={pagination}
                        handleTableChange={this.handleTableChange}
                    />
                    <div className="process_list">
                        <div style={{ position: 'absolute' }}>分派人员：</div>
                        <div style={{ marginLeft: 60, overflow: 'hidden' }}>
                            {processList.map(item => (
                                <div className="process_item" key={item.employeeCode}>
                                    {item.employeeName}({item.employeeCode})
                                    <span style={{ marginLeft: 6 }}>【人员到位时间：{item.entryDate}】</span>
                                    <span style={{ marginLeft: 6, color: '#0e77ca', cursor: 'pointer' }} onClick={() => this.download(item.vitaeId)}>【个人简历：{item.vitaeName}】</span>
                                    <Icon
                                        className="icon"
                                        type="close-circle"
                                        onClick={() => this.removeProcess(item)}
                                    />
                                </div>
                            ))}
                        </div>
                    </div>
                    <div style={{ marginTop: 10, marginBottom: 20 }}>
                        <span>补充说明：</span>
                        <TextArea
                            rows={4}
                            placeholder="请描述本次预分配人员的优势项"
                            value={requirementExplain}
                            onChange={this.changeReason}
                            style={{ width: 780, marginLeft: 10, verticalAlign: 'top' }}
                        />
                    </div>
                </Spin>
                <AssignEmployee ref={el => this.assignEmployeeRef = el} process={this.process} />
            </Modal>
        );
    }
}

export default ProcessRequirement;



// WEBPACK FOOTER //
// ./src/components/user/require/components/ProcessRequirement.js